import { PropsWithChildren, useEffect, useRef } from 'react';
import { FunctionComponent } from 'react';

interface ClickAwayListenerProps extends PropsWithChildren {
    onClickAway: () => void;
    disabled?: boolean;
}

export const ClickAwayListener: FunctionComponent<ClickAwayListenerProps> = ({
    children,
    onClickAway,
    disabled = false
}) => {
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (!disabled && containerRef.current && !containerRef.current.contains(event.target as Node)) {
                onClickAway();
            }
        };

        if (!disabled) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [disabled, onClickAway]);

    return <div ref={containerRef}>{children}</div>;
};

export default ClickAwayListener;
